module.exports = __webpack_public_path__ + "img/icon-search-white.e770efcd.svg";